import moment from 'moment';

export default ['$scope', 'users', 'User', '$timeout', 'locale', function($scope, users, User, $timeout, locale) {
  this.updateRange = () => {
    let start;
    const value = this.selectedRange || 'all';
    switch (value) {
      case 'custom':
        $timeout(() => $scope.pickerActive = true, 0);
        return;
      case 'all':
        start = this.getStartDate();
        break;
      case 'ytd':
        start = moment().startOf('year');
        break;
      default:
        start = moment().subtract(+value[0], value[1]);
    }
    this.range = { startDate: start.toDate(), endDate: this.getEndDate().toDate(), selectedValue: value };
  };

  this.rangeList = () => {
    const diffMonths = this.getEndDate().diff(this.getStartDate(), 'months');
    const list = [];
    if (diffMonths >= 1) { list.push('1M'); }
    if (diffMonths >= 3) { list.push('3M'); }
    if ((this.getStartDate() != null ? this.getStartDate().year() : undefined) < this.getEndDate().year()) { list.push('ytd'); }
    if (diffMonths >= 12) { list.push('1Y'); }
    list.push('all');
    list.push('custom');
    return list;
  };

  this.rangeName = function(name) {
    if (name === '1M') { return locale.isFrench() ? '1 Mois' : '1 Month'; }
    if (name === '3M') { return locale.isFrench() ? '3 Mois' : '3 Months'; }
    if (name === 'ytd') { return locale.isFrench() ? 'Cumul ann.' : 'YTD'; }
    if (name === '1Y') { return locale.isFrench() ? '1 ans' : '1 Year'; }
    if (name === 'all') { return locale.isFrench() ? 'Entièreté' : 'All Time'; }
    if (name === 'custom') { return locale.isFrench() ? 'Spécifier' : 'Custom'; }
  };

  this.getStartDate = function() {
    if (this.startDate) {
      const date = moment(this.startDate);
      if (date.isValid()) return date;
    }
    return moment(0);
  };

  this.getEndDate = function() {
    if (this.endDate) {
      const date = moment(this.endDate);
      if (date.isValid()) return date;
    }
    return moment();
  };

  // This is done because the start and end date are set asynchronously
  $scope.$watch('ctrl.startDate', newValue => {
    this.updateRange();
  });

  $scope.$watch('ctrl.endDate', newValue => {
    this.updateRange();
  });

  this.selectRange = function(value) {
    this.selectedRange = value;
    if (value !== 'custom') {
      User.updatePreferences({ id: this.userId, dashboardPreferences: { chartRange: value }});
    }
    this.updateRange();
  }

  this.selectedRange = '1M';
  const currentUser = users.getCurrentUser();
  const prefs = currentUser.preferences;
  this.userId = currentUser.id;
  if (prefs && prefs.dashboard && prefs.dashboard.chart_range) {
    this.selectedRange = prefs.dashboard.chart_range
  }
  this.updateRange();

  return this;
}];
